export default __webpack_public_path__ + "static/media/Soulslake Mead.4e822ca6.jpg";